import client from '../httpClient';

// mokuhyoSet004
const mokuhyoSetDeleteApi = (targetId) => {
  return client.delete(`/target-settings/${targetId}`);
};

export default mokuhyoSetDeleteApi;
